(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Playable", [], factory);
	else if(typeof exports === 'object')
		exports["Playable"] = factory();
	else
		root["Playable"] = factory();
})(window, function() {
return 